import {
  Checkbox,
  ClickAwayListener,
  FormControl,
  FormControlLabel,
  Grow,
  makeStyles,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from '@material-ui/core'
import { CheckBox } from '@material-ui/icons'
import React, { useState } from 'react'
import CustomImage from './CustomImage'
import FilterListIcon from '@material-ui/icons/FilterList'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    zIndex: 120,
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  hover: {
    cursor: 'pointer',
  },
}))
function CustomFilter() {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)

  // const [file, setFile] = useState('')
  const [fileName, setFileName] = useState('')
  const [progress, setProgress] = useState(false)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open)
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = open
  }, [open])
    const data = [
      { label: 'Lorem Ipsum' },
      { label: 'Lorem Ipsum' },
      { label: 'Lorem Ipsum' },
      { label: 'Lorem Ipsum' },

      { label: 'Lorem Ipsum' },
      { label: 'Lorem Ipsum' },
      { label: 'Lorem Ipsum' },
    ]
  return (
    <div>
      <div
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        style={{ marginTop: '14px' }}
      >
        <FilterListIcon />
      </div>
      <Popper open={open} anchorEl={anchorRef.current} className={classes.root} role={undefined} transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper style={{ padding: '10px' }}>
              <Typography style={{ fontWeight: 600, textAlign: 'center' }}>Filter</Typography>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  <FormControl component="fieldset">
                    {data.map((item, index) => (
                      <MenuItem onClick={handleClose}>
                        <FormControlLabel
                          value="start"
                          control={<Checkbox color="primary" />}
                          label={item.label}
                          labelPlacement="start"
                          style={{ padding: '2px', margin: '2px' }}
                        />
                      </MenuItem>
                    ))}
                  </FormControl>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}

export default CustomFilter
